export const actions = {
  FORM_STARTED: "Initiate",
  FORM_SUBMIT_SUCCESS: "Submit Success",
  FORM_SUBMIT_FAIL: "Submit Fail"
};

export const fireGtmEvent = (category, action, label) => {
  if (typeof window === "undefined") {
    return;
  }

  if (typeof window["dataLayer"] !== "undefined") {
    // Send the event into GTM
    window["dataLayer"].push({
      event: "analyticsEvent",
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: null,
      eventNonInt: false
    });
  }
};



// WEBPACK FOOTER //
// ./js/analytics/gtm.js